// PQ Tube's index filters (tube/_filters).
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js. Keyed on form[data-tube-filter], which only the tube
// home renders, so it is inert everywhere else.
//
// Two things, and nothing the form needs: a change submits the form (the
// Apply button does the same with no script), and the programme select is
// narrowed to the chosen institution by MOVING its <optgroup> nodes into and
// out of a detached holder. Hiding is not an option: Safari and every mobile
// native picker ignore `hidden` and `display: none` on an <option>, as
// course_finder.js records. Nothing is disabled.

function bind(form) {
  const institution = form.querySelector("[data-tube-filter-institution]");
  const programme = form.querySelector("[data-tube-filter-programme]");

  if (institution && programme) {
    const holder = document.createDocumentFragment();
    const groups = Array.from(programme.querySelectorAll("optgroup[data-institution]"));

    const narrow = () => {
      // Read before the DOM moves: removing the group holding the selected
      // option resets the select.
      const chosen = programme.value;
      const wanted = institution.value;
      groups.forEach((group) => holder.appendChild(group));
      groups
        .filter((group) => !wanted || group.dataset.institution === wanted)
        .forEach((group) => programme.appendChild(group));
      programme.value = chosen;
      if (programme.value !== chosen) programme.value = "";
    };

    narrow();
    institution.addEventListener("change", narrow);
  }

  form.addEventListener("change", () => {
    if (typeof form.requestSubmit === "function") form.requestSubmit();
    else form.submit();
  });
}

function start() {
  document.querySelectorAll("form[data-tube-filter]").forEach(bind);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
